import type { GoogleAuthInterface } from "./interface"
import { useGoogleAuthNative } from "./google-auth-native"
import { useGoogleAuthWeb } from "./google-auth-web"

export function useGoogleAuth(): GoogleAuthInterface {
	const platform = useWebPlatform()

	if (platform === "web")
		return useGoogleAuthWeb()

	else if (platform === "android")
		return useGoogleAuthNative()

	else
		throw new Error(`Recaptcha Not Implemented for ${platform}`)
}
